import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { CloseOutlined, DeleteOutlined } from '@ant-design/icons'
const { RangePicker } = DatePicker;
const { Option } = Select;

import { 
  getCompanyName,
  getPublishList,
  getDictList,
  getCompanyList
} from '../../actions/publish'

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#0F25D1 !important",
      borderRadius: "2px !important",
    },
    container: {
      paddingTop: "20px",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: 'flex',
      justifyContent: 'space-between'
    },
    select: {
      width: '100%'
    },
    tableContainer: {
      '& .ant-table-cell-row-hover': {
        background: '#f0fbff !important'
      },
      '& td.ant-table-column-sort': {
        background: '#f0fbff !important'
      }
    },
    labelBox: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      height: '80px',
      marginBottom: '12px',
      padding: '10px 16px 0',
      background: '#fff',
      overflow: 'auto',
      borderRadius: '5px',
      boxShadow: '0 3px 1px -2px rgba(0, 0, 0, .05), 0 2px 2px 0 rgba(0, 0, 0, .05), 0 1px 5px 0 rgba(0, 0, 0, .05)'
    },
    label: {
      height: "25px",
      margin: "0 10px 10px 0",
      lineHeight: "23px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #ddd",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#0F25D1",
        borderColor: "#0F25D1",
      },
    }
  };
};

let timer = null

class PublishList extends Component {
  constructor(props){
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    companyArr: [], // 申请人下拉数据
    dataSourceArr: [], // 数据来源下拉数据
    labelList: [], // 厂商数据
    selectLabel: '', // 选中厂商
    selectType: '', // 选中厂商查询对应字段
    columns: [],
    blongingArr: [],//国产或进口
    applianceArr: [ ], // 器械或体诊  
    registerTypeArr: [ ], // 注册类型  
    addressArr: [ ], // 审批部门所在地  
    registerModalityArr: [ ], // 注册形式  
    applianceLevelArr: [ ], // 器械等级
    applianceTypeArr: [ ], // 器械类型  
    inputBak: '',
    valueBak: '',
    data: [],
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      KeyWord: "",
      RatifyDate: [],
      AcceptACaseNumber: "",
      BelongingCountryID: undefined,
      AppliancePhysicalDiagnosticReagentID: undefined,
      RegistrationTypeID: undefined,
      RegistrationNumber: "",
      LocationOfApprovalDepartmentID: undefined,
      RegisterModalityID: undefined,
      RegisterYear: "",
      ApplianceGradeID: undefined,
      ApplianceType: undefined,
      ProductName: "",
      Applicant: "",
      Agent: "",
      DataSources: undefined,
      ModelSpecifications: "",
      StructureAndComposition: "",
      ScopeOfApplication: "",
      Remarks: "",
      ChangeSituation: "",
    },
    labelObj: { // 筛选项key - label对应关系
      KeyWord: "关键词",
      SearchType: '标签',
      RatifyDate: '批准日期',
      AcceptACaseNumber: '受理号',
      BelongingCountryID: '国产/进口',
      AppliancePhysicalDiagnosticReagentID: '器械/体诊试剂',
      RegistrationTypeID: '注册类型',
      RegistrationNumber: '注册证编号',
      LocationOfApprovalDepartmentID: '审批部门所在地',
      RegisterModalityID: '注册形式',
      RegisterYear: '注册年份',
      ApplianceGradeID: '器械等级',
      ApplianceType: '器械类别',
      ProductName: '产品名称',
      Applicant: '申请人',
      Agent: '代理人',
      DataSources: '数据来源',
      ModelSpecifications: "型号规格",
      StructureAndComposition: "结构及组成",
      ScopeOfApplication: "适用范围",
      Remarks: "备注",
      ChangeSituation: "变更情况",
    },
    allKeys: [],
    showKeys: [],
    labelListObj: { // 下拉选项反显 key-list对应关系
      BelongingCountryID: 'blongingArr',
      AppliancePhysicalDiagnosticReagentID: 'applianceArr',
      RegistrationTypeID: 'registerTypeArr',
      LocationOfApprovalDepartmentID: 'addressArr',
      RegisterModalityID: 'registerModalityArr',
      ApplianceGradeID: 'applianceLevelArr',
      ApplianceType: 'applianceTypeArr',
      DataSources: 'dataSourceArr',
    },
    selectKeys: [
      'BelongingCountryID', 
      'AppliancePhysicalDiagnosticReagentID', 
      'RegistrationTypeID', 
      'LocationOfApprovalDepartmentID', 
      'RegisterModalityID',
      'ApplianceGradeID',
      'ApplianceType',
      'DataSources',
    ],
    sortObj: {},
    page: {
      PageNo: 1,
      PageSize: 10
    },
    total: 0,
    scrollObj: {
      x: 4260,
      y: 600
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条数据'
        // return '当前已筛选出【' + this.state.paginationObj.total + '】条，总数据量【' + this.state.paginationObj.allTotal + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    }
  };

  componentDidMount() {
    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
        showKeys: ['KeyWord']
      }, () => this.initData())
    } else {
      this.initData()
    }


    this.getTableHeight()

    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    this.initParam()
    this.initCompany()

    let allKeys = []
    for (let key in this.state.labelObj) {
      allKeys.push({
        key: key,
        label: this.state.labelObj[key]
      })
    }
    this.setState({
      allKeys: allKeys,
    })
  }

  getTableHeight = () => {
    // 计算表格高度
    let height = window.innerHeight
    let lineHeight = document.getElementById('searchBar').offsetHeight
    this.setState({
      scrollObj: {
        x: 4260,
        y: height - lineHeight - 211
      }
    })
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        RatifyDate: [],
        AcceptACaseNumber: "",
        BelongingCountryID: undefined,
        AppliancePhysicalDiagnosticReagentID: undefined,
        RegistrationTypeID: undefined,
        RegistrationNumber: "",
        LocationOfApprovalDepartmentID: undefined,
        RegisterModalityID: undefined,
        RegisterYear: "",
        ApplianceGradeID: undefined,
        ApplianceType: undefined,
        ProductName: "",
        Applicant: "",
        Agent: "",
        DataSources: undefined,
        ModelSpecifications: "",
        StructureAndComposition: "",
        ScopeOfApplication: "",
        Remarks: "",
        ChangeSituation: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'RatifyDate') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (this.state.selectKeys.indexOf(key) > -1) {
          if (key == 'DataSources') {
            label = this.state[this.state.labelListObj[key]].filter(v => {
              return showValue.indexOf(v.ID) > -1
            }).map(v => {
              return v.Name
            }).join()
          } else {
            label = this.state[this.state.labelListObj[key]].find(v => {
              return v.ID == showValue
            }).Name
          }
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    }, () => this.getTableHeight())
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initData = () => {
    
    let RatifyDate = this.state.form.RatifyDate
    let DataSources = this.state.form.DataSources
    let param =  Object.assign({}, this.state.form, this.state.page, this.state.sortObj)
    if (this.state.selectType && !this.state.form[this.state.selectType]) {
      param[this.state.selectType] = this.state.selectLabel
    }
    if (RatifyDate && RatifyDate.length > 0) {
      param.Time_KS = RatifyDate[0].format("YYYY-MM-DD")
      param.Time_JS = RatifyDate[1].format("YYYY-MM-DD")
    }
    if (DataSources && DataSources instanceof Array && DataSources.length > 0) {
      param.DataSources = DataSources.join()
    }
    delete(param.RatifyDate)
    

    getPublishList(param).then(res => {
      if (!res.Error && res.DataList) {
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.DataNumber
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber
        this.setState({
          data: res.DataList.map(v => {
            v.key = v.ID
            return v
          }),
          paginationObj: newPaginationObj,
          loading: false
        }, () => {
          this.getColumns()
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }

  initParam = () => {
    // 公司名称
    getCompanyName({
      CompanyAssociatedTableName: 'medicalEquipment'
    }).then(res => {
      if (!res.Error) {
        this.setState({
          companyArr: res.DataList 
        }, () => {
          this.getColumns()
        })
      }
    })

    // 数据来源
    getDictList({
      Type: 'approved_document_data_source'
    }).then(res => {
      if (!res.Error) {
        this.setState({
          dataSourceArr: res.DataList
        }, () => {
          this.getColumns()
        })
      }
    })
    // 国产或进口
    getDictList({
      Type: 'belonging_country'
    }).then(res => {
      if (!res.Error) {
        this.setState({
          blongingArr: res.DataList
        }, () => {
          this.getColumns()
        })
      }
    })
    // 器械或体诊
    getDictList({
      Type: 'approval_type'
    }).then(res => {
      if (!res.Error) {
        this.setState({
          applianceArr: res.DataList
        }, () => {
          this.getColumns()
        })
      }
    })
    // 注册类型
    getDictList({
      Type: 'approval_application_type'
    }).then(res => {
      if (!res.Error) {
        this.setState({
          registerTypeArr: res.DataList
        }, () => {
          this.getColumns()
        })
      }
    })
    // 审批部门所在地
    getDictList({
      Type: 'drug_administration'
    }).then(res => {
      if (!res.Error) {
        this.setState({
          addressArr: res.DataList
        }, () => {
          this.getColumns()
        })
      }
    })
    // 注册形式
    getDictList({
      Type: 'drug_source'
    }).then(res => {
      if (!res.Error) {
        this.setState({
          registerModalityArr: res.DataList
        }, () => {
          this.getColumns()
        })
      }
    })
    // 器械等级
    getDictList({
      Type: 'drug_classification'
    }).then(res => {
      if (!res.Error) {
        this.setState({
          applianceLevelArr: res.DataList
        }, () => {
          this.getColumns()
        })
      }
    })
    // 器械类型
    getDictList({
      Type: 'medical_device_type'
    }).then(res => {
      if (!res.Error) {
        this.setState({
          applianceTypeArr: res.DataList
        }, () => {
          this.getColumns()
        })
      }
    })
  }

  initCompany = () => {
    let host = window.location.host
    getCompanyList({
      // ManufacturerName: '艾尔建'
    }).then(res => {
      this.setState({
        labelList: res.DataList || []
      })
    })
  }

  getColumns = () => {
    let classes = this.props.classes

    let columns = [
      {
        title: '发布日期',
        dataIndex: 'AnnounceDate',
        key: 'AnnounceDate',
        width: 160,
      },
      {
        title: '批准日期',
        dataIndex: 'RatifyDate',
        key: 'RatifyDate',
        width: 220,
        ...this.getDateFilterOption('RatifyDate', classes),
      },
      {
        title: '受理号',
        dataIndex: 'AcceptACaseNumber',
        width: 120,
        key: 'AcceptACaseNumber',
        ...this.getInputFilterOption('AcceptACaseNumber', '受理号', classes),
      },
      {
        title: '国产/进口',
        dataIndex: 'BelongingCountry',
        width: 150,
        key: 'BelongingCountryID', 
        ...this.getSelectFilterOption('BelongingCountryID', '国产/进口', classes, this.state.blongingArr),
      },
      {
        title: '器械/体诊试剂',
        dataIndex: 'AppliancePhysicalDiagnosticReagent',
        width: 160, 
        key: 'AppliancePhysicalDiagnosticReagentID',
        ...this.getSelectFilterOption('AppliancePhysicalDiagnosticReagentID', '器械/体诊试剂', classes, this.state.applianceArr),
      },
      {
        title: '注册类型',
        dataIndex: 'RegistrationType',
        width: 140,
        key: 'RegistrationTypeID',
        ...this.getSelectFilterOption('RegistrationTypeID', '注册类型', classes, this.state.registerTypeArr),
      },
      {
        title: '注册证编号',
        dataIndex: 'RegistrationNumber',
        width: 140,
        key: 'RegistrationNumber',
        ...this.getInputFilterOption('RegistrationNumber', '注册证编号', classes),
      },
      {
        title: '审批部门所在地',
        dataIndex: 'LocationOfApprovalDepartment',
        width: 160,
        key: 'LocationOfApprovalDepartmentID',
        ...this.getSelectFilterOption('LocationOfApprovalDepartmentID', '审批部门所在地', classes, this.state.addressArr),
      },
      {
        title: '注册形式',
        dataIndex: 'RegisterModality',
        width: 130,
        key: 'RegisterModalityID',
        ...this.getSelectFilterOption('RegisterModalityID', '注册形式', classes, this.state.registerModalityArr),
      },
      {
        title: '注册年份',
        dataIndex: 'RegisterYear',
        width: 130,
        key: 'RegisterYear',
        ...this.getInputFilterOption('RegisterYear', '注册年份', classes),
      },
      {
        title: '器械等级',
        dataIndex: 'ApplianceGrade',
        width: 130,
        key: 'ApplianceGradeID',
        ...this.getSelectFilterOption('ApplianceGradeID', '器械等级', classes, this.state.applianceLevelArr),
      },
      {
        title: '器械类别',
        dataIndex: 'ApplianceType',
        width: 130,
        key: 'ApplianceType',
        ...this.getSelectFilterOption('ApplianceType', '器械类别', classes, this.state.applianceTypeArr),
      },
      {
        title: '产品名称',
        dataIndex: 'ProductName',
        width: 260,
        key: 'ProductName',
        ...this.getInputFilterOption('ProductName', '产品名称', classes),
      },
      {
        title: '申请人',
        dataIndex: 'Applicant',
        width: 200,
        key: 'Applicant', 
        ...this.getInputFilterOption('Applicant', '申请人', classes)
      },
      {
        title: '代理人',
        dataIndex: 'Agent',
        width: 210,
        key: 'Agent',
        ...this.getInputFilterOption('Agent', '代理人', classes)
      },
      {
        title: '数据来源',
        dataIndex: 'DataSources',
        key: 'DataSources',
        width: 180,
        ...this.getSelectFilterOption('DataSources', '数据来源', classes, this.state.dataSourceArr, true)
      },
      {
        title: '型号规格',
        dataIndex: 'ModelAndSpecification',
        key: 'ModelAndSpecification',
        width: 240,
      },
      {
        title: '结构及组成',
        dataIndex: 'StructureAndComposition',
        key: 'StructureAndComposition',
        width: 350,
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.StructureAndComposition || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
      {
        title: '适用范围',
        dataIndex: 'ScopeOfApplication',
        key: 'ScopeOfApplication',
        width: 350,
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.ScopeOfApplication || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
      {
        title: '备注',
        dataIndex: 'OfficialWebsiteRemarks',
        key: 'OfficialWebsiteRemarks',
        width: 350,
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.OfficialWebsiteRemarks || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
      {
        title: '变更情况',
        dataIndex: 'AlterationSituation',
        key: 'AlterationSituation',
        width: 350,
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.AlterationSituation || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
    ]

    this.setState({
      columns: columns
    })
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      loading: true
    }, () => {
      this.getColumns()
      this.initData()
    });
  };

  handleReset = (clearFilters) => {
    clearFilters()
  }

  
  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  handleSearchParams = (value, isSearch, key) => {
    if (isSearch) {
      if (key == 'ApplicantIDOrAgentID') {
        clearTimeout(timer)
        timer = setTimeout(() => {
          getCompanyName({
            CompanyAssociatedTableName: 'medicalEquipment',
            Name: value,
            CompanyName: value
          }).then(res => {
            if (!res.Error) {
              this.setState({
                companyArr: res.DataList || []
              }, () => {
                this.getColumns()
              })
            }
          })
        }, 300)
      }
    }
  }

  getDateFilterOption = (key, classes) => {
    let { filteredInfo } = this.state;
    filteredInfo = filteredInfo || {};
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div className={classes.dateFilter}>
          <div>
            <RangePicker 
              value={selectedKeys[0]}
              onChange={value => setSelectedKeys(value ? [value] : [])} 
            />
          </div>
          <div className={classes.btnLine}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => this.handleSearch(key, selectedKeys[0], confirm)}
              size="small"
              style={{ width: 80 }}
            >
              查询
            </Button>
            <Button size="small" style={{ width: 80 }}  onClick={clearFilters}>
              重置
            </Button>
          </div>
        </div>  
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      filteredValue: filteredInfo[key] || null,
    }
  }
  getSelectFilterOption= (key, name, classes, options, multiple, isSearch) => {
    let { filteredInfo } = this.state;
    filteredInfo = filteredInfo || {};
    let valueBak = ''
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div className={classes.defaultFilter}>
          <div className={classes.selectBox}>
            <Select
              className={classes.select}
              showSearch
              optionFilterProp="children"
              value={selectedKeys[0]}
              mode={multiple ? 'multiple' : ''}
              onSearch={(value) => this.handleSearchParams(value, isSearch, key)}
              onBlur={
                () => {
                  if (key == 'ApplicantIDOrAgentID' && !valueBak) {
                    let input = sessionStorage.getItem('inputBak')
                    setSelectedKeys(input ? [input] : [])
                  }
                }
              }
              placeholder={`请选择${name}`}
              onChange={value => {
                valueBak = value
                return setSelectedKeys(value ? [value] : [])
              }} 
              filterOption={(input, option) => {
                sessionStorage.setItem('inputBak', input)
                return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }}
              notFoundContent={key == 'Applicant' ? null : 'Not Found'}
            >
              {
                options.map(v => {
                  return (
                    <Option value={v.ID} key={v.ID}>{v.Name}</Option>
                  )
                })
              }
            </Select>
          </div>
          <div className={classes.btnLine}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => this.handleSearch(key, selectedKeys[0], confirm)}
              size="small"
              style={{ width: 80 }}
            >
              查询
            </Button>
            <Button size="small" style={{ width: 80 }} onClick={() => this.handleReset(clearFilters)}>
              重置
            </Button>
          </div>
        </div>  
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      filteredValue: filteredInfo[key] || null,
    }
  }
  getInputFilterOption = (key, name, classes) => {
    let { filteredInfo } = this.state;
    filteredInfo = filteredInfo || {};
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div className={classes.defaultFilter}>
          <div>

            <Input 
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])} 
              placeholder={`请输入${name}`}/>
          </div>
          <div className={classes.btnLine}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => this.handleSearch(key, selectedKeys[0], confirm)}
              size="small"
              style={{ width: 80 }}
            >
              查询
            </Button>
            <Button size="small" style={{ width: 80 }} onClick={() => this.handleReset(clearFilters)}>
              重置
            </Button>
          </div>
        </div>  
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      filteredValue: filteredInfo[key] || null,
    }
  }

  handleSearch = (key, value, confirm) => {
    let newForm = this.state.form
    newForm[key] = value
    this.setState({
      form: newForm,
      loading: true
    }, () => {
      this.searchForm()
    })
    confirm()
  }
  

  pageChange = (page, pageSize) => {
    if (page == this.state.page.PageNo && pageSize == this.state.page.PageSize) {
      return
    }
    this.setState({
      page: {
        PageNo: page,
        PageSize: pageSize
      },
      loading: true
    }, () => this.initData())
  }

  onChangeShowKeys = (e) => {
    this.setState({
      showKeys: e
    })
  }

  handleClickLabel = (value) => {
    if (value) {
      let data = this.state.labelList.find(v => {
        return v.SearchType == value
      })
      this.setState({
        selectLabel: data.Name,
        selectType: data.SearchType,
      })  
    } else {
      this.setState({
        selectLabel: '',
        selectType: '',
      })  
    }
  }

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            {/* <div className="form-item">
              <div className="form-label">检索字段</div>
              <Select
                className={classes.select}
                placeholder="请选择"
                mode="multiple"
                value={this.state.showKeys}
                onChange={this.onChangeShowKeys} 
              >
                {
                  this.state.allKeys.map((v, i) => {
                    return (
                      <Option value={v.key} key={i}>{v.label}</Option>
                    )
                  })
                }
              </Select>
            </div> */}
            {/* {
              this.state.showKeys.indexOf('KeyWord') > -1 && */}
              <div className="form-item">
                <div className="form-label">关键词</div>
                <Input  value={this.state.form.KeyWord}
                  onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                  placeholder="请输入关键词"/>
              </div>
            {/* }
            {
              this.state.showKeys.indexOf('SearchType') > -1 &&
              <div className="form-item">
                <div className="form-label">标签</div>
                <Select
                  className={classes.select}
                  placeholder="请选择"
                  value={this.state.SearchType}
                  onChange={(e) => this.handleClickLabel(e)} 
                >
                  {
                    this.state.labelList.map((v, i) => {
                      return (
                        <Option value={v.SearchType} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            }
            {
              this.state.showKeys.indexOf('RatifyDate') > -1 && */}
              <div className="form-item">
                <div className="form-label">批准日期</div>
                <RangePicker
                  value={this.state.form.RatifyDate}
                  onChange={(value) => this.onChangeForm(value, 'RatifyDate')}
                />
              </div>
            {/* }
            {
              this.state.showKeys.indexOf('AcceptACaseNumber') > -1 && */}
              <div className="form-item">
                <div className="form-label">受理号</div>
                <Input  value={this.state.form.AcceptACaseNumber}
                  onChange={(e) => this.onChangeForm(e.target.value, 'AcceptACaseNumber')} 
                  placeholder="请输入受理号"/>
              </div>
            {/* }
            {
              this.state.showKeys.indexOf('BelongingCountryID') > -1 &&
              <div className="form-item">
                <div className="form-label">国产/进口</div>
                <Select
                  className={classes.select}
                  placeholder="请选择"
                  value={this.state.form.BelongingCountryID}
                  onChange={(e) => this.onChangeForm(e, 'BelongingCountryID')} 
                >
                  {
                    this.state.blongingArr.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            }
            {
              this.state.showKeys.indexOf('AppliancePhysicalDiagnosticReagentID') > -1 && */}
              <div className="form-item">
                <div className="form-label">器械/体诊试剂</div>
                <Select
                  className={classes.select}
                  placeholder="请选择"
                  value={this.state.form.AppliancePhysicalDiagnosticReagentID}
                  onChange={(e) => this.onChangeForm(e, 'AppliancePhysicalDiagnosticReagentID')} 
                >
                  {
                    this.state.applianceArr.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            {/* }
            {
              this.state.showKeys.indexOf('RegistrationTypeID') > -1 && */}
              <div className="form-item">
                <div className="form-label">注册类型</div>
                <Select
                  className={classes.select}
                  placeholder="请选择"
                  value={this.state.form.RegistrationTypeID}
                  onChange={(e) => this.onChangeForm(e, 'RegistrationTypeID')} 
                >
                  {
                    this.state.registerTypeArr.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            {/* }
            {
              this.state.showKeys.indexOf('RegistrationNumber') > -1 && */}
              <div className="form-item">
                <div className="form-label">注册证编号</div>
                <Input  value={this.state.form.RegistrationNumber}
                  onChange={(e) => this.onChangeForm(e.target.value, 'RegistrationNumber')} 
                  placeholder="请输入注册证编号"/>
              </div>
            {/* }
            {
              this.state.showKeys.indexOf('LocationOfApprovalDepartmentID') > -1 &&           
              <div className="form-item">
                <div className="form-label">审批部门所在地</div>
                <Select
                  className={classes.select}
                  placeholder="请选择"
                  value={this.state.form.LocationOfApprovalDepartmentID}
                  onChange={(e) => this.onChangeForm(e, 'LocationOfApprovalDepartmentID')} 
                >
                  {
                    this.state.addressArr.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            }
            {
              this.state.showKeys.indexOf('RegisterModalityID') > -1 && 
              <div className="form-item">
                <div className="form-label">注册形式</div>
                <Select
                  className={classes.select}
                  placeholder="请选择"
                  value={this.state.form.RegisterModalityID}
                  onChange={(e) => this.onChangeForm(e, 'RegisterModalityID')} 
                >
                  {
                    this.state.registerModalityArr.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            }
            {
              this.state.showKeys.indexOf('RegisterYear') > -1 &&
              <div className="form-item">
                <div className="form-label">注册年份</div>
                <Input  value={this.state.form.RegisterYear}
                  onChange={(e) => this.onChangeForm(e.target.value, 'RegisterYear')} 
                  placeholder="请输入注册年份"/>
              </div>
            }
            {
              this.state.showKeys.indexOf('ApplianceGradeID') > -1 && */}
              <div className="form-item">
                <div className="form-label">器械等级</div>
                <Select
                  className={classes.select}
                  placeholder="请选择"
                  value={this.state.form.ApplianceGradeID}
                  onChange={(e) => this.onChangeForm(e, 'ApplianceGradeID')} 
                >
                  {
                    this.state.applianceLevelArr.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            {/* }
            {
              this.state.showKeys.indexOf('ApplianceType') > -1 && */}
              <div className="form-item">
                <div className="form-label">器械类别</div>
                <Select
                  className={classes.select}
                  placeholder="请选择"
                  value={this.state.form.ApplianceType}
                  onChange={(e) => this.onChangeForm(e, 'ApplianceType')} 
                >
                  {
                    this.state.applianceTypeArr.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>
            {/* }
            {
              this.state.showKeys.indexOf('ProductName') > -1 && */}
              <div className="form-item">
                <div className="form-label">产品名称</div>
                <Input  value={this.state.form.ProductName}
                  onChange={(e) => this.onChangeForm(e.target.value, 'ProductName')} 
                  placeholder="请输入产品名称"/>
              </div>
            {/* }
            {
              this.state.showKeys.indexOf('Applicant') > -1 && */}
              <div className="form-item">
                <div className="form-label">申请人</div>
                <Input  value={this.state.form.Applicant}
                  onChange={(e) => this.onChangeForm(e.target.value, 'Applicant')} 
                  placeholder="请输入申请人"/>
              </div>

              <div className="form-item">
                <div className="form-label">代理人</div>
                <Input  value={this.state.form.Agent}
                  onChange={(e) => this.onChangeForm(e.target.value, 'Agent')} 
                  placeholder="请输入代理人"/>
              </div>
            
              <div className="form-item">
                <div className="form-label">数据来源</div>
                <Select
                  className={classes.select}
                  placeholder="请选择"
                  mode="multiple"
                  value={this.state.form.DataSources}
                  onChange={(e) => this.onChangeForm(e, 'DataSources')} 
                >
                  {
                    this.state.dataSourceArr.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
              </div>   

              <div className="form-item">
                <div className="form-label">型号规格</div>
                <Input  value={this.state.form.ModelSpecifications}
                  onChange={(e) => this.onChangeForm(e.target.value, 'ModelSpecifications')} 
                  placeholder="请输入型号规格"/>
              </div>
              <div className="form-item">
                <div className="form-label">结构及组成</div>
                <Input  value={this.state.form.StructureAndComposition}
                  onChange={(e) => this.onChangeForm(e.target.value, 'StructureAndComposition')} 
                  placeholder="请输入结构及组成"/>
              </div>
              <div className="form-item">
                <div className="form-label">适用范围</div>
                <Input  value={this.state.form.ScopeOfApplication}
                  onChange={(e) => this.onChangeForm(e.target.value, 'ScopeOfApplication')} 
                  placeholder="请输入适用范围"/>
              </div>
              <div className="form-item">
                <div className="form-label">备注</div>
                <Input  value={this.state.form.Remarks}
                  onChange={(e) => this.onChangeForm(e.target.value, 'Remarks')} 
                  placeholder="请输入备注"/>
              </div>
              <div className="form-item">
                <div className="form-label">变更情况</div>
                <Input  value={this.state.form.ChangeSituation}
                  onChange={(e) => this.onChangeForm(e.target.value, 'ChangeSituation')} 
                  placeholder="请输入变更情况"/>
              </div>
          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search" id="searchBar">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">批件发布数据</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value" title={item.value}>{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                scroll={this.state.scrollObj} 
                pagination={this.state.paginationObj}
                bordered
                />
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(PublishList));
